import { render, staticRenderFns } from "./JourneyCart.vue?vue&type=template&id=3387c8cc&"
import script from "./JourneyCart.vue?vue&type=script&lang=js&"
export * from "./JourneyCart.vue?vue&type=script&lang=js&"
import style0 from "./JourneyCart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports